import Vue from 'vue'
import Vuex from 'vuex'
import notifications from '@/store/notifications'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ownerDisconnected: false
  },
  mutations: {
    connectOwner (state) {
      state.ownerDisconnected = false
    },
    disconnectOwner (state) {
      state.ownerDisconnected = true
    }
  },
  modules: {
    notifications
  }
})
